import { useEffect, useState } from 'react'

import abiMarketPlace from 'abi/abi-market-place.json'
import { AppAdmin } from 'api/app-admin'
import { useContractViem } from 'hooks/contract/use-contract-viem'
import { useContractManager } from 'hooks/use-contract-manager'
import { logError } from 'utils/logger'

const useMarketPlaceDetail = () => {
  const [scMarketPlace, setScMarketPlace] = useState(null)

  const contract: any = useContractViem(scMarketPlace, abiMarketPlace)

  const { isContractManager, checkContractManager } = useContractManager({ contract })

  const getSettingMarketPlace = async () => {
    try {
      const res = await AppAdmin.getConfigSetting()
      if (res?.data.success) {
        const data = res.data.data || {}
        setScMarketPlace(data.marketplace_contract)
      }
    } catch (error) {
      logError('Error fetching data: ', error)
    }
  }

  useEffect(() => {
    getSettingMarketPlace()
  }, [])

  return {
    isContractManager,
    contract,
    checkContractManager,
  }
}

export default useMarketPlaceDetail
